"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _cookies = require("hub-http/helpers/cookies");

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _auth = require("../selectors/auth");

var _usageTracker = require("../utils/usageTracker");

var STORAGE_KEY = 'ecosystem.marketplace.apps.welcome';

var getItem = function getItem() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

var setItem = function setItem() {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch (e) {
    return;
  }
};

var AsyncWelcomeModal = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: 'welcome-modal' */
    '../components/WelcomeModal');
  }
});

var WelcomeModalContainer = function WelcomeModalContainer(_ref) {
  var isTestUser = _ref.isTestUser;
  var subscreen = 'welcome modal';
  var usageTracker = (0, _usageTracker.getUsageTracker)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var trackView = function trackView() {
    usageTracker.track('pageview', {
      subscreen: subscreen
    });
  };

  var trackInteraction = function trackInteraction(action) {
    usageTracker.track('interaction', {
      subscreen: subscreen,
      action: action
    });
  };

  var handleClose = function handleClose() {
    setOpen(false);
    setItem();
  };

  (0, _react.useLayoutEffect)(function () {
    var item = getItem();
    var cookie = (0, _cookies.getCookie)(STORAGE_KEY, document.cookie);

    if (cookie && !item) {
      setItem();
    }

    var timeoutId = !(item || cookie) && setTimeout(function () {
      return setOpen(true);
    }, 200);
    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  if (isTestUser || !open) {
    return null;
  }

  return _react.default.createElement(AsyncWelcomeModal, {
    onClose: handleClose,
    onOpenComplete: trackView,
    onTrackInteraction: trackInteraction
  });
};

WelcomeModalContainer.propTypes = {
  isTestUser: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isTestUser: (0, _auth.getIsTestUser)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(WelcomeModalContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/containers/WelcomeModalContainer.js
// module id = 910
// module chunks = 209 210 211 212